import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Box, Button, Image, Text, useColorMode } from "theme-ui";
import dropdownicon from "../assets/images/arrow.svg";
import dropdownWhite from "../assets/images/dropdownwhite.svg";
const CustomArrow: React.FC = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const popoverRef = useRef<HTMLDivElement>(null);

  const handleOptionClick = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('fcmSubscribed')
  };
  const togglePopover = (event: any) => {
    setIsPopoverOpen(!isPopoverOpen);
  };
  const handleClickOutside = (event: MouseEvent) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
      setIsPopoverOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [colorMode] = useColorMode();

  return (
    <div ref={popoverRef}>

      <Button
        onClick={togglePopover}
        sx={{ variant: 'styles.button', backgroundColor: 'transparent', border: 'none', paddingRight: '52px' }}
      >

        <Image src={colorMode === 'light' ? dropdownicon : dropdownWhite} alt="Dropdown Icon" />
      </Button>

      {isPopoverOpen && (
        <Box

          sx={{
            position: 'absolute',
            gap: '8px',
            right: 2,
            zIndex: 1,
            backgroundColor: colorMode === 'light' ? "white" : "#323c56",
            border: '1px solid #black',
            boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.06)',
            borderRadius: '4px',
            // minWidth: '189px',
            // padding: '20px 4px',
            fontSize: 'larger',
            // top: '62px'
          }}>
          {/* <Link to={"/user"} className="text-hover" style={{ textDecoration: 'none' }}>
            Setting
          </Link> */}
          <Link to={'login'} style={{ textDecoration: 'none' }}>
            <Text className="text-hover" sx={{ color: colorMode === "light" ? "black" : "white" }} as="p" onClick={handleOptionClick}>
              LogOut
            </Text>
          </Link>
        </Box>
      )
      }
    </div >
  )
};

export default CustomArrow;
